export var UTMS = ['utmSource', 'utmContent', 'utmMedium', 'utmCampaign', 'utmTerm'];
//# sourceMappingURL=index.js.map